import Cookies from "js-cookie";

document.addEventListener('alpine:init', () => {
    Alpine.data('cookiesAllowed', () => ({
        cookiesAllowed: false,
        checkCookies() {
            console.log("checking cookies");
            const cc = Cookies.get('cookieconsent_status');
            this.cookiesAllowed = cc && (cc === 'allow');
        }
    }));
});
